export default "__VITE_ASSET__14da736d__"